/* ===== Brokerage & statutory charges breakdown =====
   Replicates the monitor's close-time formula exactly (verified 296/296
   trades reconcile to the rupee with the stored `charges` total):
     bv = entryPremium × qty ; sv = exitPremium × qty ; tv = bv + sv
     brokerage = min(₹20, 0.03% of tv) × 2 legs
     STT       = 0.0625% of sell value
     exch txn  = 0.053% of turnover
     GST       = 18% on (brokerage + exch txn)
     SEBI      = 0.0001% of turnover
     stamp     = 0.003% of buy value */

export function chargesBreakdown(t) {
  const ep = t?.entryPremium, xp = t?.exitPremium, qty = t?.qty;
  if (!ep || !xp || !qty) return null;
  const bv = ep * qty, sv = xp * qty, tv = bv + sv;
  const brokerage = Math.min(20, tv * 0.0003) * 2;
  const stt = sv * 0.000625;
  const txn = tv * 0.00053;
  const gst = (brokerage + tv * 0.00053) * 0.18;
  const sebi = tv * 0.000001;
  const stamp = bv * 0.00003;
  const total = brokerage + stt + txn + gst + sebi + stamp;
  return { brokerage, stt, txn, gst, sebi, stamp, total, turnover: tv };
}

export const CHARGE_KEYS = [
  ["brokerage", "Brokerage"],
  ["stt", "STT"],
  ["txn", "Exch txn"],
  ["gst", "GST"],
  ["sebi", "SEBI"],
  ["stamp", "Stamp"],
];

/* sum breakdowns across trades; falls back to the stored total for trades
   missing premiums so the Total column always reconciles with the book */
export function sumCharges(trades) {
  const acc = { brokerage: 0, stt: 0, txn: 0, gst: 0, sebi: 0, stamp: 0, total: 0, turnover: 0, n: 0, unresolved: 0 };
  for (const t of trades) {
    const b = chargesBreakdown(t);
    if (b) {
      for (const k of Object.keys(b)) acc[k] += b[k];
      acc.n++;
    } else if (typeof t?.charges === "number") {
      acc.total += t.charges; acc.n++; acc.unresolved++;
    }
  }
  return acc;
}
